import { EModel } from './model';
export let EOutboundNumberFilterRef;
(function (EOutboundNumberFilterRef) {
  EOutboundNumberFilterRef["Provider"] = "provider";
  EOutboundNumberFilterRef["Facility"] = "facility";
  EOutboundNumberFilterRef["User"] = "user";
  EOutboundNumberFilterRef["Patient"] = "patient";
})(EOutboundNumberFilterRef || (EOutboundNumberFilterRef = {}));
export let EOutboundNumberVendor;
(function (EOutboundNumberVendor) {
  EOutboundNumberVendor["Twilio"] = "twilio";
  EOutboundNumberVendor["Bandwidth"] = "bandwidth";
  EOutboundNumberVendor["Interfax"] = "interfax";
})(EOutboundNumberVendor || (EOutboundNumberVendor = {}));
export let EOutboundNumberChannel;
(function (EOutboundNumberChannel) {
  EOutboundNumberChannel["Sms"] = "sms";
  EOutboundNumberChannel["Voice"] = "voice";
  EOutboundNumberChannel["Fax"] = "fax";
  EOutboundNumberChannel["Whatsapp"] = "whatsapp";
})(EOutboundNumberChannel || (EOutboundNumberChannel = {}));
export let EDecommissionedStatus;
(function (EDecommissionedStatus) {
  EDecommissionedStatus["Spam"] = "spam";
  EDecommissionedStatus["NotFoundInVendor"] = "not-found-in-vendor";
})(EDecommissionedStatus || (EDecommissionedStatus = {}));
export let EOutboundNumberNumberType;
(function (EOutboundNumberNumberType) {
  EOutboundNumberNumberType["LongCode"] = "long-code";
  EOutboundNumberNumberType["ShortCode"] = "short-code";
  EOutboundNumberNumberType["TollFree"] = "toll-free";
})(EOutboundNumberNumberType || (EOutboundNumberNumberType = {}));
export let EOutboundNumberStatus;
(function (EOutboundNumberStatus) {
  EOutboundNumberStatus["HostingStarted"] = "hosting-started";
  EOutboundNumberStatus["HostingVerificationStarted"] = "hosting-verification-started";
  EOutboundNumberStatus["HostingVerificationCompleted"] = "hosting-verification-completed";
  EOutboundNumberStatus["HostingVerificationFailed"] = "hosting-verification-failed";
  EOutboundNumberStatus["HostingCompleted"] = "hosting-completed";
  EOutboundNumberStatus["HostingFailed"] = "hosting-failed";
  EOutboundNumberStatus["PortingStarted"] = "porting-started";
  EOutboundNumberStatus["PortingCompleted"] = "porting-completed";
  EOutboundNumberStatus["PortingFailed"] = "porting-failed";
  EOutboundNumberStatus["Active"] = "active";
  EOutboundNumberStatus["Inactive"] = "inactive";
  EOutboundNumberStatus["Decommissioned"] = "decommissioned";
  EOutboundNumberStatus["Released"] = "released";
  EOutboundNumberStatus["Quarantined"] = "quarantined";
})(EOutboundNumberStatus || (EOutboundNumberStatus = {}));
export let EOutboundNumberType;
(function (EOutboundNumberType) {
  EOutboundNumberType["Hosted"] = "hosted";
  EOutboundNumberType["Ported"] = "ported";
  EOutboundNumberType["Owned"] = "owned";
})(EOutboundNumberType || (EOutboundNumberType = {}));
export const fieldsOutboundNumber = {
  available: {
    type: 'Boolean'
  },
  channels: {
    type: 'Option',
    values: Array
  },
  countryCode: {
    type: 'Text'
  },
  createdAt: {
    type: 'Date'
  },
  decommissioned: {
    type: 'Object'
  },
  deleted: {
    type: 'Number'
  },
  externalId: {
    type: 'Object'
  },
  externalStatus: {
    type: 'Object'
  },
  filters: {
    type: 'Object',
    array: true
  },
  name: {
    type: 'Text'
  },
  number: {
    type: 'Text'
  },
  numberType: {
    type: 'Option',
    values: EOutboundNumberNumberType
  },
  registration: {
    type: 'ID',
    ref: EModel.MessageRegistration
  },
  status: {
    type: 'Option',
    values: EOutboundNumberStatus
  },
  type: {
    type: 'Option',
    values: EOutboundNumberType
  },
  updatedAt: {
    type: 'Date'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  vendor: {
    type: 'Option',
    values: EOutboundNumberVendor
  }
};